<template>
    <section
        :id="slice.primary.anchorName || undefined"
        class="slice slice-content-grid slice-content-grid--default"
        aria-label="content-grid"
        data-testid="slice-content-grid-default"
    >
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" data-testid="slice-content-grid-title" />
            <PrismicRichText
                v-if="slice.primary.description"
                :field="slice.primary.description"
                class="slice-description"
                data-testid="slice-content-grid-description"
            />

            <div class="slice-body slice-content-grid__cards">
                <MktCard v-for="(item, i) in slice.items" :key="i" :data-testid="`slice-content-grid-card--${i}`">
                    <template #image>
                        <MktMaltPrismicImage
                            :image-field="item.image"
                            class="slice-content-grid__card-image"
                            height="50"
                            width="300"
                            loading="lazy"
                            sizes="600px"
                            :data-testid="`slice-content-grid-card-image--${i}`"
                        />
                    </template>
                    <template #title>
                        <span :data-testid="`slice-content-grid-card-title--${i}`">{{ item.title }}</span>
                    </template>
                    <PrismicRichText :field="item.text" :data-testid="`slice-content-grid-card-text--${i}`" />
                </MktCard>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ContentGridSlice} from '@prismicio-types';
    import {MktCard, MktMaltPrismicImage} from '#components';

    type ContentGridDefaultInZone = Extract<ContentGridSlice, {variation: 'default'}>;
    defineProps(getSliceComponentProps<ContentGridDefaultInZone>());
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-content-grid--default {
        .slice-content-grid__cards {
            max-width: 1130px;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: var(--joy-core-spacing-6);

            @include mq.screen_sm(min) {
                gap: var(--joy-core-spacing-8);
            }

            .card {
                width: 100%;

                @include mq.screen_sm(min) {
                    max-width: 350px;
                }

                a,
                a:visited {
                    color: var(--joy-color-text-default);
                    text-decoration: underline;
                    text-underline-position: under;
                    cursor: pointer;
                    transition: color var(--joy-transition-duration-default) var(--joy-transition-timing-function);

                    &:hover {
                        color: var(--joy-color-neutral-60);
                    }
                }
            }

            .card-image {
                margin: 0 auto;
                height: 50px;

                img {
                    width: auto;
                    height: 100%;
                }
            }
        }
    }
</style>
